﻿import { RenderReactAtSite } from "widgets/commonComponents/inline/renderReactAtSite"
import { SiteArticleSocialShareNew1280 } from "../articleSocialShare1280Component/articleSocialShareNew1280";
import { SiteArticleActionBar1280 } from "../articleSocialShare1280Component/SiteArticleActionBar1280";
import { SummaryDataItem } from "./articleHeader1280AiSummary";

interface SiteArticleHeaderShareProps {
    categorySubChannel: string
    author: string
    articleId: string
    showComments: boolean
    showShare?: boolean
    isSpotim: boolean
    actionBarMode?: boolean
    lang?:string
    title?: string
    shouldRenderSummary?: boolean
    summaryData?: SummaryDataItem[]
    desktopSummaryMountId?: string
    isMagazine?: boolean
    readAloudUrl?: string | null
    readAloudDuration?: number | null
    mediaImageUrl?: string
    domain?: string
    imagesDomain?: string
    /** Sticky/secondary bars should pass false so the main bar owns the floating player. */
    isReadAloudPlayerHost?: boolean
}

export class SiteArticleHeaderShareWrapper1280 extends React.Component<SiteArticleHeaderShareProps>{

    render() {
        const {
            categorySubChannel,
            author,
            articleId,
            showComments,
            showShare,
            isSpotim,
            actionBarMode,
            lang,
            title,
            shouldRenderSummary,
            summaryData,
            desktopSummaryMountId,
            isMagazine,
            readAloudUrl,
            readAloudDuration,
            mediaImageUrl,
            domain,
            imagesDomain,
            isReadAloudPlayerHost = true,
        } = this.props
        const Ar =  lang && lang.includes("ar");
        if(Ar) return null;
        if (actionBarMode) {
            return (
                <RenderReactAtSite>
                    <SiteArticleActionBar1280
                        categorySubChannel={categorySubChannel}
                        author={author}
                        articleId={articleId}
                        showComments={showComments}
                        showShare={showShare}
                        lang={lang}
                        title={title}
                        shouldRenderSummary={shouldRenderSummary}
                        summaryData={summaryData || []}
                        desktopSummaryMountId={desktopSummaryMountId}
                        isMagazine={!!isMagazine}
                        readAloudUrl={readAloudUrl}
                        readAloudDuration={readAloudDuration}
                        mediaImageUrl={mediaImageUrl}
                        domain={domain}
                        imagesDomain={imagesDomain}
                        isReadAloudPlayerHost={isReadAloudPlayerHost}
                    />
                </RenderReactAtSite>
            )
        }
        else  return (
            <RenderReactAtSite>
                <SiteArticleSocialShareNew1280 categorySubChannel={categorySubChannel}
                    author={author} 
                    articleId={articleId}
                    showComments={showComments}
                    isSpotim={isSpotim}
                    lang={lang}
                    title={title}
                />
            </RenderReactAtSite>
        )
    }
}
